import { isNumber } from 'radash';

import { ZoneHelpers } from '@diagram/helpers/ZoneHelpers';

import { ZoneValidationError, ZoneValidationErrorType, ZoneValidator } from 'models';

const MIN_CAPACITANCE = 1e-9;

const checkFaultCapacitanceSize: ZoneValidator['validator'] = ({ diagram, zones }) => {
    const errors: ZoneValidationError[] = [];

    zones.forEach((zone) => {
        const endpointsWithSmallCapacitance: string[] = [];

        zone.connections.forEach((connection) => {
            const { from, to } = connection;

            [from, to].forEach((endpoint) => {
                if (!isNumber(endpoint.port)) return;

                const componentInstance = diagram.componentInstances[endpoint.componentInstanceId];
                if (!componentInstance) return;

                if (!ZoneHelpers.isControlZoneEndpoint(componentInstance, endpoint.port)) return;

                const portSpec = componentInstance.specifications.electrical.ports?.[endpoint.port];
                if (!portSpec) return;

                const hasCapacitance = 'capacitance' in portSpec && portSpec.capacitance?.nom;

                if (hasCapacitance) {
                    const capacitanceValue = portSpec.capacitance?.nom;
                    if (
                        capacitanceValue &&
                        capacitanceValue < MIN_CAPACITANCE &&
                        !endpointsWithSmallCapacitance.includes(endpoint.componentInstanceId)
                    ) {
                        endpointsWithSmallCapacitance.push(endpoint.componentInstanceId);
                    }
                }
            });
        });

        if (endpointsWithSmallCapacitance.length) {
            const affectedComponents = zone.componentInstances.filter((ci) =>
                endpointsWithSmallCapacitance.includes(ci.id),
            );
            ZoneHelpers.warning(errors, ZoneValidationErrorType.FAULT_CAPACITANCE_TOO_SMALL, zone, affectedComponents);
        }
    });

    return errors;
};

export { checkFaultCapacitanceSize };
